import { Trash2 } from "lucide-react";
import React from "react";

import { IgIconButton, IgIconButtonProps } from "@intelligems/ig-theme";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { useTheme } from "@mui/material";
import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";

type DeleteButtonProps = {
  mod: EmbeddedMod;
} & IgIconButtonProps;

export const DeleteButton = ({
  className,
  mod,
  ...props
}: DeleteButtonProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  return (
    <IgIconButton
      aria-label="delete"
      color="error"
      size="small"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        void dispatch(ExperienceBuilderAction.deleteMod(mod.id));
      }}
      {...props}
    >
      <Trash2 size={16} color={theme.igIconColors.error} />
    </IgIconButton>
  );
};
